<svg width="24"
     height="24"
     viewBox="0 0 24 24"
     fill="none"
     xmlns="http://www.w3.org/2000/svg"
     [class]="computedClass()">
  <!-- <path d="M9.21694 18.5L15.6133 12.7433C16.0547 12.3461 16.0547 11.6539 15.6133 11.2567L9.21694 5.5"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round" /> -->
  <path d="M15.6133 18.5L9.21694 12.7433C8.77556 12.3461 8.77556 11.6539 9.21694 11.2567L15.6133 5.5"
        stroke="currentColor"
        stroke-width="3"
        stroke-linecap="round" />
</svg>